import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class DigiCert extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M23.789,13.7c-.378-4.39-3.406-7.342-5.752-10.521.984-1.438,3.179-.984,4.768-.681A14.356,14.356,0,0,0,15.766,0C10.847-.074,6.911,2.8,3.278,5.981,1.083,5.3,2.6,2.953,2.6,1.288a13.138,13.138,0,0,0-2.422,8.4A15.087,15.087,0,0,0,2.9,17.258l3.179,3.633c-1.06,1.74-3.179.984-4.769.681a13.147,13.147,0,0,0,8.4,2.422A14.584,14.584,0,0,0,17.2,21.269l3.633-3.179a4.889,4.889,0,0,1,.681,4.769A13.99,13.99,0,0,0,23.789,13.7Zm-3.482.151c-.908,1.135-2.043,2.5-2.043,2.5a16.079,16.079,0,0,1-2.573,2.27,9.585,9.585,0,0,1-5.3,1.892H9.939l-.076-.075-2.119-2.12a28.019,28.019,0,0,1-2.195-2.5,9.789,9.789,0,0,1-1.892-5.3V9.841L5.776,7.948C8.273,5.754,11,3.786,14.4,3.786h.151L16.22,5.981c1.59,2.2,3.709,4.314,4.012,7.341,0,0,.075.454.075.53Z" />
      </svg>
    );
  }
}

export default DigiCert;
